export default "__VITE_ASSET__BGlqJY0O__"